import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 24 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 8\" id=\"icon-arrow\"><path d=\"M24 4a.55.55 0 00-.162-.39L20.384.162a.554.554 0 00-.782.781l2.51 2.504H.532a.553.553 0 000 1.105h21.58l-2.51 2.506a.551.551 0 10.782.78l3.453-3.447A.55.55 0 0024 4z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow.svg
// module id = 444
// module chunks = 4